import { Pipe, PipeTransform } from '@angular/core';
import { OrderedMap } from 'immutable';

@Pipe({
  name: 'keyValuePair',
})
export class KeyValuePairPipe implements PipeTransform {
  transform(obj: any, args?: any): KeyValuePair[] {
    let pairs = [];

    if (OrderedMap.isOrderedMap(obj)) {
      obj.forEach((value, key) => pairs.push({ key, value }));
    } else {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          pairs.push({
            key,
            value: obj[key],
          });
        }
      }
    }

    return pairs;
  }
}

interface KeyValuePair {
  key: string;
  value: any;
}
